import { render, staticRenderFns } from "./StudentsReport.vue?vue&type=template&id=2dc551fa&"
import script from "./StudentsReport.vue?vue&type=script&lang=js&"
export * from "./StudentsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports